import { useService } from 'react-reservice';

import { resetPasswordExperienceService } from './service';

export const useResetPasswordExperience = () => useService(resetPasswordExperienceService, (context) => context);
